<template>
    <div class="content-createaccount container">
        <h4 class="text-center">Criar Conta</h4>
        <form @submit.prevent="sendRegister()">
            <div class="form-group row">
                <div class="col-md-12">
                    <input type="text" name="name" v-model="name" placeholder="Nome" required>
                </div>
                <div class="col-md-12">
                    <input type="email" name="email" v-model="email" placeholder="Email" required>
                </div>
                <div class="col-md-12">
                    <input type="text" name="mobile" v-model="mobile" placeholder="Telemóvel" class="phone" maxlength="9"  @keypress="onlyNumbers" required>
                    <span class="prefix">+351</span>
                </div>
                <div class="col-md-12">
                    <input type="password" name="password" v-model="password" placeholder="Palavra-passe" required>
                </div>
            </div>
            <div class="content-input-check">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="regulamento" v-model="regulamento" required>
                    <label class="form-check-label" for="regulamento">
                        Declaro que li e aceito o <a @click="goToPage('regulamento')">Regulamento da Campanha Café da Sorte.</a>
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="termos" v-model="termos" required>
                    <label class="form-check-label" for="termos">
                        Declaro que li e aceito os <a @click="goToPage('termos-e-condicoes-web')">Termos de Utilização do Website</a>.
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="privacidade" v-model="privacidade" required>
                    <label class="form-check-label" for="privacidade">
                        Declaro ter lido a<a href="/storage/app/media/informacoeslegais/politicadeprivacidade.pdf" target="_blank" rel="noopener"> Política de Privacidade </a>e ter tomado conhecimento da forma como os meus dados pessoais são tratados.
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="comunicacao" v-model="comunicacao">
                    <label class="form-check-label" for="comunicacao">
                        Consinto, de forma livre, consciente e informada, que Manuel Rui Azinhais Nabeiro, Unipessoal, Lda. a recolha e trate os dados pessoais por mim fornecidos para ações de marketing e publicidade, nos termos melhor descritos na <a href="/storage/app/media/informacoeslegais/politicadeprivacidade.pdf" target="_blank" rel="noopener">Política de Privacidade </a>
                    </label>
                </div>
            </div>
            <div class="form-buttons">
                <div class="btn btn-next">
                    <button type="submit">seguinte</button>
                </div>
                <div class="btn btn-cancel">
                    <router-link tag="button" to="/home">cancelar</router-link>
                </div>
            </div>
        </form>
        <PhoneValidation />
    </div>
</template>
<script>
import PhoneValidation from '../../components/modals/PhoneValidation.vue';


    export default {
        data() {
            return {
                name: '',
                mobile: '',
                email: '',
                password: '',
                termos: false,
                regulamento: false,
                privacidade: false,
                comunicacao: false,
            }
        },
        components: {
            PhoneValidation
        },
        methods: {
            goToPage(slug) {
                this.$router.push({ name: "LegalInformation", params: { slug: slug } });
                if (this.$route.name == "LegalInformation") {
                    this.$router.go();
                }
            },
            onlyNumbers(event) {
                const charCode = event.which ? event.which : event.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
                }
            },
                async sendRegister(){
                if (!this.isValidEmail(this.email)) {
                    this.$swal.fire({
                        type: 'error',
                        title: 'Erro',
                        text: 'Por favor, insira um email válido.',
                        timer: 3000,
                    });
                    return;
                }

                if (!this.isValidMobile(this.mobile)) {
                    this.$swal.fire({
                        type: 'error',
                        title: 'Erro',
                        text: 'Por favor, insira um número de telemóvel válido.',
                        timer: 3000,
                    });
                    return;
                }
                if (this.mobile.charAt(0) !== '9') {
                    this.$swal.fire({
                        type: 'error',
                        title: 'Erro',
                        text: 'O número de telemóvel deve começar com 9.',
                        timer: 3000,
                    });
                    return;
                }
                if(this.acceptedterms === false){
                    this.$swal.fire({
                        type: 'error',
                        title: 'Erro',
                        text: 'Deve aceitar os termos e condições',
                        timer: 3000,
                    });
                    return;
                }
                const data = {
                    name: this.name,
                    mobile: this.mobile,
                    email: this.email,
                    password: this.password,
                    termos: this.termos,
                    regulamento: this.regulamento,
                    privacidade: this.privacidade,
                    comunicacao: this.comunicacao,
                }
                await this.$store.dispatch("accountRegister", data)
                    .then((response) => {
                        if (response.data.success === true) {
                            this.$bvModal.show('modal-phonevalidation');
                        } else {
                            this.$swal.fire({
                                type: 'error',
                                title: 'Erro',
                                text: response.data.error.error.context.payload.telemovel.message,
                                timer: 3000,
                            });
                        }
                    })
                    .catch((error) => {
                        this.$swal.fire({
                            type: 'error',
                            title: 'Erro',
                            text: error,
                            timer: 3000,
                        });
                    });
                
        },
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        isValidMobile(mobile) {
            const mobileRegex = /^[1-9]{1}[0-9]{8}$/;
            return mobileRegex.test(mobile);
        }
    }
}
</script>
<style lang="scss">
.content-createaccount {
    margin: 240px auto 120px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (max-width: 991px) {
        text-align: left;
        margin: 180px auto 120px auto;
    }
    h4{
        width: 100%;
        max-width: 536px;
        text-transform: uppercase;
        margin-bottom: 30px;
        padding: 0 15px;
        @media screen and (max-width: 991px) {
            text-align: left!important;
        }
    }
    form{
        max-width: 536px;
        right: 0;
        left: 0;
    }
    .form-group {
        margin-bottom: 30px;
        display: flex;
        gap: 30px;
        margin: 10px;
        input {
            width: 100%;
            height: 56px;
            padding: 10px;
            border: 1px solid var(--gray);
            border-radius: 10px;
            outline: none;
            text-align: center;
            font-family: 'Font Bold';
            font-size: 18px;
            color: #000;
            &:focus {
                border: 1px solid #000;
            }
            &::placeholder {
                font-family: 'Font Regular';
                font-size: 18px;
                color: var(--gray)
            }
        }
    }
    .form-check{
        padding-left: 0!important;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .content-input-check {
        display: flex;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        margin: 20px;
        input[type="checkbox"]:checked:before {
            content: "";
            height: 100%;
            width: 100%;
            background: url("~@/assets/img/icons/check.png");
            background-position: center !important;
            background-repeat: no-repeat !important;
            background-color: var(--white);
        }
        input[type="checkbox"]:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background-color: var(--white);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 15px;
            border: 0;
        }
        input[type="checkbox"] {
            position: relative;
            height: 30px;
            width: 30px;
            border-radius: 15px;
            border: 1px solid #173F35;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            outline: 0 !important;
            margin: 0;
            margin-right: 20px;
        }
        label {
            font-size: 18px;
            font-family: "Font Regular";
            color: black;
            width: calc(100% - 50px);
            text-align: left;
            padding-top: 2px;
            margin-bottom: 0;
            a{
                font-size: 18px;
                font-family: "Font Regular";
                color: var(--black);
                text-decoration: underline !important;
                transition: 500ms;
                &:hover,
                &:focus {
                    cursor: pointer;
                    opacity: 0.8;
                    text-decoration: underline !important;
                    text-decoration-color: var(--main-color);
                }
            }
        }
    }
    .form-buttons {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        gap: 30px;
        margin-top: 45px;
        width: 100%;
        .btn-next{
            button {
                width: 340px;
                max-width: 100%;
                height: 56px;
                border: none;
                border-radius: 10px;
                background: rgb(254,206,9);
                background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                color: black;
                font-family: "Font Bold";
                font-size: 18px;
                text-transform: uppercase;
                transition: 500ms;
                &:hover,
                &:focus {
                    cursor: pointer;
                    border: 1px solid #545353;
                }
            }
        }
        .btn-cancel{
            button {
                width: 340px;
                max-width: 100%;
                height: 56px;
                border-radius: 10px;
                border: 1px solid #B8B8B8;
                background-color: var(--white);
                color: #B8B8B8;
                font-family: "Font Bold";
                font-size: 18px;
                text-transform: uppercase;
                transition: 500ms;
                &:hover,
                &:focus {
                    cursor: pointer;
                    border: 1px solid #545353;
                    color:black;
                }
            }
        }
            
    }
}
.phone{
    position: relative;
}
.prefix{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 30%;
    font-family: 'Font Regular';
    font-size: 18px;
    color: #000;
    @media screen and (max-width: 575px) {
        left: 25%;
    }
}
</style>